import * as React from 'react';
import { Box } from '@leagueplatform/genesis-core';
import {
  ERROR_TYPES,
  ErrorState,
} from '@telus-alberta-health-web/shared-module';

function ErrorPage() {
  return (
    <Box
      css={{
        width: '100vw',
        height: '100dvh',
        display: 'flex',
        justifyContent: 'center',
      }}
    >
      <ErrorState errorType={ERROR_TYPES.API_ERROR} error={null} />
    </Box>
  );
}

export default ErrorPage;
